var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"loading":_vm.loading,"search-config":_vm.searchConfig,"isDownload":true,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onExportData":_vm.onExport,"onChangePage":val=>{_vm.$store.commit('setPage',val);_vm.getData()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }